import apiClient from "./client";

export const installmentsSummary = {
  getByToken: () => apiClient.get("/installments"),
};
